import React from "react";
import clientConfig from "../../client-config";
import PortableText from "./portableText";
import * as styles from './threeColumnTileWithIcon.module.css';


function TCTWIItem(props) {

    let itemClass = styles.itemWrap+" stagger-item";

    return (
        <div className={itemClass}>
            <div className={styles.headingWrap}>
                <span>{props.item.title}</span>
                {
                    (props.item.image && !props.item.image.disabled) ? <img src={props.item.image.image.asset.url} alt={props.item.title} /> : ``
                }
            </div>
            <div className={styles.contentTextWrap}>
                <PortableText blocks={props.item.desc} />
            </div>
            {
                (props.item.link && props.item.ctalabel) ?
                    <div className={styles.cpcta}><a href={props.item.link}>{props.item.ctalabel}</a></div>
                    : ``
            }
        </div>
    );
}
  
export default TCTWIItem;